import React, {PureComponent} from 'react'
// import PropTypes from 'prop-types'
import Container from "../../Container"
import Col from "../../Col"
import Caption from '../../Caption'
import UslugaItem from './UslugaItem'

export default class List extends PureComponent {
  // static propTypes = {
  //   uslugasFetch: PropTypes.shape().isRequired,
  //   children: PropTypes.node.isRequired
  // }

  render() {
    const {uslugasFetch, children} = this.props
    return (
      <Container>
        {uslugasFetch.length === 0 ? null :
        <Col xs={6} sm={12} md={24} lg={24}>
          <Caption position="center">{children}</Caption>
          <ul className="dashboard__items-wrapper">
            {uslugasFetch.map(item => <UslugaItem key={item.id} data={item} />)}
          </ul>
        </Col>
        }
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./components/DashboardExecutor/List/index.jsx